<template>
  <div class="h-100 w-100">

    <b-form @submit="onSubmit" class="h-100 w-100">
      <b-form-row class="d-flex h-100 overflow-hidden" style="flex-wrap: nowrap; margin: 0;">
        <b-col cols="12" sm="6" class="brand-master-modal--left">
          <overlay-scrollbars :options="{ scrollbars: { autoHide: false }, overflowBehavior: { y: 'scroll', x: 'hidden' }, className : 'os-theme-dark os-theme-gekko' }">

            <b-form-row>
              <b-col cols="12" lg="12">
                <b-form-group id="input-group-1" label-class="gk-modal-label" :label="$gettext('Trade Name*')" label-for="input-1">
                  <b-form-input data-analytics-click id="input-2" v-model="brand.name" required :placeholder="$gettext('Planet Express')"></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="12" lg="12">
                <b-form-group id="input-group-7" label-class="gk-modal-label" label-for="input-7">
                  <b-form-checkbox id="input-7" @change="onDefaultChange" class="checkbox-bg-color" v-model="brand.is_default" switch>
                    <span v-translate>Default brand</span>&nbsp;
                    <span v-b-tooltip.hover 
                        :title="brand.is_default ? $gettext('This brand will be preselected for new invoices.') : $gettext('If you select this brand, it will be preselected for new invoices.')">
                      <font-awesome-icon icon="fa-regular fa-circle-question" class="tooltip-icon tooltip-icon--question"/>
                    </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="12" lg="12">
                <b-form-group id="input-group-2" label-class="gk-modal-label" :label="$gettext('Email')" label-for="input-2">
                  <b-form-input data-analytics-click id="input-2" v-model="brand.brand_email" type="email" required :placeholder="$gettext('goodnews@momcorp.com')"></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="12" lg="12">
                <b-form-group id="input-group-logo" label-class="gk-modal-label" :label="$gettext('Logo')" label-for="input-logo">

                  <div class="company-settings-logo wizard-modal-onboarding">
                    <CompanyLogo 
                      :wizard="false"
                      :show-name="true"
                      :type="'brand'"
                      @attach-logo="attachLogo"
                      @detach-logo="detachLogo"
                    />
                  </div>
                </b-form-group>
              </b-col>
            </b-form-row>
          
            <div class="modal-form-legend">
              <legend style="font-size: 20px; margin-bottom: 0.5rem">{{ $gettext('Invoice Fields') }}</legend>
              <small class="text-muted form-text pb-3">{{ $gettext('The information below will be displayed on your invoice. You can either hide fields or leave them empty if you do not want to display them on your invoice.') }}</small>
            </div>
            <b-form-row>
              <b-col cols="12" lg="6">
                <b-form-group id="input-group-2">
                  <div class="gk-modal-label pb-0 gk-modal-label--has-actions">
                    <span :class="{ 'hidden-base-field': hiddenBaseFields.includes('brand_address') }" class="text-unassigned">{{ $gettext('Address') }}</span>
                    <GekkoButton
                      @click="toogleHiddenBaseField('brand_address')"
                      :icon="(hiddenBaseFields.includes('brand_address')) ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"
                      :id="'base-field-label-edit-brand_address'"
                      class="text-info p-0 ml-1"
                      :class="(hiddenBaseFields.includes('brand_address')) ? 'text-unassigned' : 'text-unassigned'"
                      variant="link"
                      size="sm"
                    />
                    <b-tooltip :target="'base-field-label-edit-brand_address'" triggers="hover">
                      <span v-if="hiddenBaseFields.includes('brand_address')">{{ $gettext('Show this field on your invoice') }}</span>
                      <span v-else>{{ $gettext('Hide this field on your invoice') }}</span>
                    </b-tooltip>
                  </div>
                  <b-form-input 
                    data-analytics-click
                    v-model="brand.brand_address" 
                    :placeholder="$gettext('West 57th Street')" 
                    :disabled="hiddenBaseFields.includes('brand_address')" 
                    :class="{ 'hidden-base-field': hiddenBaseFields.includes('brand_address') }"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" lg="6">
                <b-form-group id="input-group-2">
                  <div class="gk-modal-label pb-0 gk-modal-label--has-actions">
                    <span :class="{ 'hidden-base-field': hiddenBaseFields.includes('brand_postal_code') }" class="text-unassigned">{{ $gettext('Postal Code') }}</span>
                    <GekkoButton
                      @click="toogleHiddenBaseField('brand_postal_code')"
                      :icon="(hiddenBaseFields.includes('brand_postal_code')) ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"
                      :id="'base-field-label-edit-brand_postal_code'"
                      class="text-info p-0 ml-1"
                      :class="(hiddenBaseFields.includes('brand_postal_code')) ? 'text-unassigned' : 'text-unassigned'"
                      variant="link"
                      size="sm"
                    />
                    <b-tooltip :target="'base-field-label-edit-brand_postal_code'" triggers="hover">
                      <span v-if="hiddenBaseFields.includes('brand_postal_code')">{{ $gettext('Show this field on your invoice') }}</span>
                      <span v-else>{{ $gettext('Hide this field on your invoice') }}</span>
                    </b-tooltip>
                  </div>
                  <b-form-input 
                    data-analytics-click
                    v-model="brand.brand_postal_code" 
                    :placeholder="$gettext('3000AD')" 
                    :disabled="hiddenBaseFields.includes('brand_postal_code')" 
                    :class="{ 'hidden-base-field': hiddenBaseFields.includes('brand_postal_code') }"
                  />
                </b-form-group>
              </b-col>

            </b-form-row>

            <b-form-row>

              <b-col cols="12" lg="6">
                <b-form-group id="input-group-2">
                  <div class="gk-modal-label pb-0 gk-modal-label--has-actions">
                    <span :class="{ 'hidden-base-field': hiddenBaseFields.includes('brand_city') }" class="text-unassigned">{{ $gettext('City') }}</span>
                    <GekkoButton
                      @click="toogleHiddenBaseField('brand_city')"
                      :icon="(hiddenBaseFields.includes('brand_city')) ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"
                      :id="'base-field-label-edit-brand_city'"
                      class="text-info p-0 ml-1"
                      :class="(hiddenBaseFields.includes('brand_city')) ? 'text-unassigned' : 'text-unassigned'"
                      variant="link"
                      size="sm"
                    />
                    <b-tooltip :target="'base-field-label-edit-brand_city'" triggers="hover">
                      <span v-if="hiddenBaseFields.includes('brand_city')">{{ $gettext('Show this field on your invoice') }}</span>
                      <span v-else>{{ $gettext('Hide this field on your invoice') }}</span>
                    </b-tooltip>
                  </div>
                  <b-form-input 
                    data-analytics-click
                    v-model="brand.brand_city" 
                    :placeholder="$gettext('New York')" 
                    :disabled="hiddenBaseFields.includes('brand_city')" 
                    :class="{ 'hidden-base-field': hiddenBaseFields.includes('brand_city') }"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" lg="6">
                <b-form-group id="input-group-6" label-class="gk-modal-label text-unassigned" :label="$gettext('Country')" label-for="input-6">
                  <b-form-select id="input-6" v-model="brand.brand_country" :options="countries" required></b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col v-for="customField in customFields" :key="'custom_fields-' + customField.fieldId" cols="12" lg="6">
                <b-form-group>
                  <!-- label name -->
                  <div class="gk-modal-label pb-0 gk-modal-label--has-actions">
                    <GekkoButton
                      v-if="!isEditingLabel(customField.fieldId)"
                      @click="showLabelInput(customField.fieldId)"
                      icon="fa-solid fa-pencil"
                      :id="'custom-field-label-edit-' + customField.fieldId"
                      :disabled="hiddenCustomFields.includes(customField.fieldId)"
                      :class="(hiddenCustomFields.includes(customField.fieldId)) ? 'text-unassigned' : 'text-blue'"
                      class="text-info p-0 ml-1"
                      variant="link"
                      size="sm"
                    />
                    <div v-if="!isEditingLabel(customField.fieldId)" class="flex-grow-1" :class="{ 'cursor-pointer': !hiddenCustomFields.includes(customField.fieldId) }" @click="showLabelInput(customField.fieldId)">
                      <span v-if="brand['label_' + customField.fieldId] != ''">{{ brand['label_' + customField.fieldId] }}</span>
                      <span v-else class="text-muted" style="opacity: 0.5;">{{ $gettext('Label') }}</span>
                    </div>
                    <div v-else class="flex-grow-1">
                      <b-form-input 
                        data-analytics-click 
                        v-model="brand['label_' + customField.fieldId]"
                        :ref="'custom-field-label-input-' + customField.fieldId"
                        :id="'custom-field-label-input-' + customField.fieldId"
                        :placeholder="$gettext('Label')"
                        class="inline-invisible-input"
                        @blur.native="handleLabelInputBlur"
                        @keydown="handleLabelInputKeydown"
                        maxlength="20"
                      />
                    </div>
                    <div>
                      <b-tooltip :target="'custom-field-label-edit-' + customField.fieldId" triggers="hover">
                        {{ $gettext('Click to edit label') }}
                      </b-tooltip>
                      <GekkoButton
                        @click="toogleHiddenCustomField(customField.fieldId)"
                        :icon="(hiddenCustomFields.includes(customField.fieldId)) ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"
                        :id="'custom-field-label-vis-' + customField.fieldId"
                        :class="(hiddenCustomFields.includes(customField.fieldId)) ? 'text-unassigned' : 'text-unassigned'"
                        class="text-info p-0 ml-1"
                        variant="link"
                        size="sm"
                      />
                      <b-tooltip :target="'custom-field-label-vis-' + customField.fieldId" triggers="hover">
                        <span v-if="hiddenCustomFields.includes(customField.fieldId)">{{ $gettext('Show this field on your invoice') }}</span>
                        <span v-else>{{ $gettext('Hide this field on your invoice') }}</span>
                      </b-tooltip>
                    </div>

                  </div>
                  <!-- field value -->
                  <b-form-input 
                    data-analytics-click
                    v-model="brand['field_' + customField.fieldId]"
                    :placeholder="$gettext('Field value')"
                    :disabled="hiddenCustomFields.includes(customField.fieldId)"
                    :class="{ 'hidden-base-field': hiddenCustomFields.includes(customField.fieldId) }"
                  />
                </b-form-group>
              </b-col>
            </b-form-row>    

            <div class="locked-fields-wrap">
              <div class="locked-fields">
                <div class="modal-form-legend">
                  <small class="text-muted form-text pb-1">{{ $gettext('While you can edit what information is displayed about your company on your invoice and create your own unique fields, please keep in mind that a correct invoice always shows your') }}</small>
                </div>
                <b-form-row>
                  <b-col cols="12" lg="12">
                    <ul class="locked-fields-list">
                      <li><span class="locked-fields-label text-muted">{{ $gettext('Tradename') }}</span></li>
                      <li v-if="currentCompany.country === 'NL'" ><span class="locked-fields-label text-muted">{{ $gettext('KVK number') }}</span></li>
                      <li><span class="locked-fields-label text-muted">{{ $gettext('VAT number (if applicable)') }}</span></li>
                      <li><span class="locked-fields-label text-muted">{{ $gettext('Company address') }}</span></li>
                    </ul>
                  </b-col>
                </b-form-row>
              </div>
            </div>

          </overlay-scrollbars>
        </b-col>
        <b-col cols="12" sm="6" class="brand-master-modal--right modal-dropzone-actions pr-0 overflow-hidden">
          <div class="modal-dropzone-actions--wrap" style="display: flex; flex-direction: column; gap: 0.5rem; height: 100%;">
            <div style="height: calc(100% - 40px);">
              <InvoiceDesign v-if="showPdfPreview" :key="previewKey" :show-controls="false" />
              <div v-else class="unavailable-pdf-preview-wrap">
                <div class="unavailable-pdf-preview">{{ $gettext('Save first to see the preview') }}</div>
              </div>
            </div>
            <div v-if="showPdfPreview" class="text-center premium-badge--inline">
              <GekkoButton
                @click="$emit('edit-design')"
                :text="$gettext('Edit design')" 
                icon="fa-solid fa-paintbrush"
                class="text-info px-0"
                variant="link"
                size="sm"
              />
              <GkBadge 
                icon="fa-solid fa-crown"
                icon-only
                type="premium"
              />
            </div>
          </div>
        </b-col>
      </b-form-row>
    </b-form>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex"

import BrandService from "@/store/services/brand.service"
import InvoiceDesign from "@/views/settings/InvoiceDesign"

import VueDropzone from "@/components/VueDropzone"
import GekkoButton from "@/components/GekkoButton"
import CompanyLogo from "@/components/wizard/steps/CompanyLogo";

export default {
  name: "BrandCreateEdit",
  components: {
    GekkoButton,
    VueDropzone,
    InvoiceDesign,
    CompanyLogo
  },
  props: {
    showPdfPreview: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      isSaving: false,
      imageSrc: null,
      customFields: [
        { fieldId: 0, defaultLabel: this.$gettext('Phone number') },
        { fieldId: 1, defaultLabel: this.$gettext('Website') },
        { fieldId: 2, defaultLabel: this.$gettext('KVK') },
        { fieldId: 3, defaultLabel: this.$gettext('BTW') },
        { fieldId: 4, defaultLabel: this.$gettext('Bank Account Number') },
        { fieldId: 5, defaultLabel: this.$gettext('Swift Number') }
      ],
      editingLabelId: null,
      previewKey: 0,
      hiddenBaseFields: [],
      hiddenCustomFields: [],
      brand: null
    }
  },
  computed: {
    ...mapGetters ({
      storeSelectedBrand: 'brands/getSelectedBrand',
      currentCompany: 'main/getCurrentCompany',
      countries: 'main/getCountryOptions'
    }),
    isEdit () {
      return !!(this.storeSelectedBrand && this.storeSelectedBrand.id)
    },
  },
  created () {
    this.brand = Object.assign({}, this.storeSelectedBrand)
    // EDIT
    this.setBrandLogoForEdit()
  },
  methods: {
    ...mapMutations({
      setSelectedBrand: 'brands/SET_SELECTED_BRAND',
      setWaitingForResponse: 'main/SET_WAITING_FOR_RESPONSE'
    }),
    ...mapActions ({
      loadCompanyBrands: 'brands/loadCompanyBrands'
    }),
    onSubmit (e) {
      this.isSaving = true
      e.preventDefault()
      this.saveBrand()
    },
    parentSubmit () {
      this.isSaving = true
      this.saveBrand()
    },
    setBrandLogoForEdit () {
      if (this.brand.id) {
        if (this.brand.brand_logo) {
          this.imageSrc = this.brand.brand_logo;
        } else {
          this.imageSrc = null;
        }
      }
    },
    attachLogo (new_logo) {
      if (new_logo instanceof File) {
        this.brand.brand_logo = new_logo
      }
    },
    detachLogo () {
      delete this.brand.brand_logo
    },
    saveBrand () {
      if (!this.currentCompany.is_premium) {
        this.$store.commit('togglePremiumModal', 'web_brands')
        return
      }

      this.setWaitingForResponse(true)
      for (var propName in this.brand) {
        if (this.brand[propName] === null || this.brand[propName] === undefined) {
          delete this.brand[propName];
        }
      }
      if (this.isEdit) { // EDIT
        if (this.brand.brand_logo && !(this.brand.brand_logo instanceof File)) {
          delete this.brand.brand_logo
        }
        BrandService.update(this.brand.id, this.brand).then( (response) => {
          this.brand.brand_logo = response.data.brand_logo;
          this.setBrandLogoForEdit()
          
          this.$store.commit('setAlert',{
            title: this.$gettext("Trade name updated"),
            text: this.$gettext("Successfully edited the trade name"),
            variant: "success",
            duration: 4
          })

          this.$emit('edited', response.data);

          // refresh pdf preview
          this.previewKey++

          // refresh store selected brand
          this.refreshSelectedBrand()

        }).catch( (response) => {
          this.saveError(response)
        }).finally(() => {
          this.setWaitingForResponse(false)
        })
      } else { // CREATE
        BrandService.create(this.brand).then( (response) => {
          this.$store.commit('setAlert', {
            title: this.$gettext("Trade name created"),
            text: this.$gettext("Successfully created the trade name"),
            variant: "success", 
            duration: 4
          });
          this.$emit('created', response.data);
        }).catch( (response) => {
          this.saveError(response)
        }).finally(() => {
          this.setWaitingForResponse(false)
        })
      }
    },
    refreshSelectedBrand () {
      this.setSelectedBrand(this.brand)
    },
    saveError (response) {
      this.isSaving = false;
      this.$store.commit('setAlert', {title: this.$gettext("Error"), text:this.$gettext("Something went wrong, brand is not saved."), variant:"danger",duration:4});
    },
    fileChanged (file) {
      this.brand.brand_logo = file;
    },
    isEditingLabel (label_id) {
      return this.editingLabelId === label_id
    },
    showLabelInput (label_id) {
      if (!this.hiddenCustomFields.includes(label_id)) {
        this.editingLabelId = label_id
        this.$nextTick(() => {
          if (this.$refs['custom-field-label-input-' + this.editingLabelId]) {
            this.$refs['custom-field-label-input-' + this.editingLabelId][0].$el.focus()
          }
        })
      }
    },
    handleLabelInputBlur () {
      this.hideLabelInput()
    },
    handleLabelInputKeydown (e) {
      if (e.key === 'Enter') {
        this.hideLabelInput()
      }
    },
    hideLabelInput () {
      this.editingLabelId = null
    },
    toogleHiddenBaseField (fieldname) {
      if (this.hiddenBaseFields.includes(fieldname)) {
        this.hiddenBaseFields = this.hiddenBaseFields.filter(item => item !== fieldname)
      } else {
        this.hiddenBaseFields.push(fieldname)
        this.brand[fieldname] = ''
      }
    },
    toogleHiddenCustomField (field_id) {
      if (this.hiddenCustomFields.includes(field_id)) {
        this.hiddenCustomFields = this.hiddenCustomFields.filter(item => item !== field_id)
      } else {
        this.hiddenCustomFields.push(field_id)
        this.brand['label_' + field_id] = ''
        this.brand['field_' + field_id] = ''
      }
    },
    onLogoSet(logo_file) {
      this.fileChanged(logo_file)

      var reader = new FileReader();
      reader.readAsDataURL(logo_file);
      reader.onload = () => {
        this.imageSrc = reader.result
      };
      reader.onerror = (error) => {
        console.log('Error: ', error);
      };

    },
    onDefaultChange() {
      if (this.brand.id !== null) { // edit
        BrandService.makeDefault(this.brand.id)
        .then(() => {
          this.loadCompanyBrands(this.currentCompany.id);
        })
        .catch((error) => {
          this.brand.is_default = !this.brand.is_default;

          if (error.status === 400) {
            this.$store.commit('setAlert', {
              title: this.$gettext("Cannot set as default"),
              text: error.data.detail,
              variant: "danger",
              duration: 4
            });
          } else {
            this.$store.commit('setAlert', {
              title: this.$gettext("Error"),
              text: this.$gettext("Something went wrong, brand is not set as default."),
              variant: "danger",
              duration: 4
            });
          }
        });
      }
    }
  }
};
</script>

<style lang="scss">
  .brand-master-modal--left {
    .os-content {
      padding: 1rem !important;
    }
    .locked-fields-wrap {
      padding: 1rem 0;
      padding-bottom: 2rem;
      .locked-fields {
        padding: 1rem;
        border-radius: $radiusMd;
        background: #f6f6f6;
        border: 1px solid $colorBorderDash;
      }
      .locked-fields-label {
        font-size: 14px;
      }
      .locked-fields-list {
        list-style: initial;
      }
    }
    .hidden-base-field {
      opacity: 0.3 !important;
    }
    .inline-invisible-input {
      background: transparent;
      border: 0;
      box-shadow: none;
      padding: 0;
      margin: 0;
      height: auto;
      border-radius: 0;
      border-bottom: 1px solid $colorBorderDash;
      &:focus {
        border-color: transparent;
        box-shadow: none;
        border-bottom: 1px solid $colorBorderDash;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .modal-dropzone-actions {
    .modal-dropzone-actions--wrap {
      .modal-dropzone-wrapper {
        flex: 1;
        height: 100%;
      }
    }
  }
  .modal-content {
    height: 100%;
    overflow: hidden;
  }
  .brand-master-modal--right {
    padding: 1rem !important;
    padding-left: 0 !important;
  }

  .gk-modal-label--has-actions {
    display: flex;
    // align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
  }

  .unavailable-pdf-preview-wrap {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .unavailable-pdf-preview {
      border-radius: $radiusLg;
      box-shadow: $dropdownShadow;
      background: white;
      padding: 2rem;
    }
  }
</style>
